import { Color, HorizontalFlex, MediumTextS, Space } from "@enxcs/dap-ui-stratos";
import styled, { css } from "styled-components";

export enum StatusEnum {
  PROCESSING = "processing",
  GENERATED = "generated",
  READY = "ready",
  PAUSED = "paused",
  FAILED = "failed",
  INTERRUPTED = "interrupted",
  RECORDING = "recording",
  READY_FOR_RECORDING = "ready_for_recording",
  UNKNOWN = "unknown",
}

const borders = {
  processing: Color.Orange.V20,
  generated: Color.Teal.V20,
  ready: Color.SpringGreen.V30,
  failed: Color.Red.V20,
  paused: Color.Neutral.V40,
  interrupted: Color.Red.V20,
  recording: Color.Blue.V20,
  ready_for_recording: Color.Neutral.V40,
  unknown: Color.Neutral.V40,
};

const background = {
  processing: Color.Orange.V10,
  generated: Color.Teal.V10,
  ready: Color.SpringGreen.V20,
  paused: Color.Neutral.V30,
  failed: Color.Red.V10,
  interrupted: Color.Red.V10,
  recording: Color.Blue.V10,
  ready_for_recording: Color.Neutral.V00,
  unknown: Color.Neutral.V30,
};

const text = {
  processing: Color.Orange.V40,
  generated: Color.Teal.V40,
  ready: Color.KellyGreen.V40,
  paused: Color.Neutral.V70,
  failed: Color.Red.V40,
  interrupted: Color.Red.V40,
  recording: Color.Blue.V50,
  ready_for_recording: Color.Neutral.V60,
  unknown: Color.Neutral.V70,
};

type StatusType = {
  status: StatusEnum;
};

export const StatusContainer = styled(HorizontalFlex).withConfig({
  shouldForwardProp: (prop) => !["status"].includes(prop),
})<StatusType>`
  gap: ${Space.V4};
  height: 28px;
  min-width: fit-content;
  width: fit-content;
  box-sizing: border-box;
  border: 1px solid ${Color.Neutral.V40};
  border-radius: ${Space.V8};
  padding: 0 ${Space.V8};
  justify-content: center;
  align-items: center;
  ${({ status }: StatusType) => css`
    background-color: ${background[status]};
    border-color: ${borders[status]};
    color: ${text[status]};
  `}
`;

export const StatusText = styled(MediumTextS).withConfig({
  shouldForwardProp: (prop) => !["status"].includes(prop),
})<StatusType>`
  min-width: max-content;
  ${({ status }: StatusType) => css`
    color: ${text[status]};
  `}
`;
